export const professionalSummary =
  'Software engineer with experience building full-stack and backend applications using React, Django, Node.js, PostgreSQL, MongoDB, and AWS. Designed REST APIs, authentication systems, SQL automation pipelines, and serverless cloud services while collaborating in GitLab-based Agile engineering environments. Strong background in backend architecture, database design, API integration, cloud-native development, and end-to-end software delivery.';

export const skillGroups = {
  Languages: ['Python', 'Java', 'JavaScript', 'SQL', 'TypeScript', 'C++'],
  Frontend: ['React', 'Angular', 'HTML5', 'CSS3', 'Responsive Web Design'],
  Backend: ['Django', 'Django REST Framework', 'Node.js', 'Express.js', 'REST APIs', 'JWT Authentication'],
  Databases: ['PostgreSQL', 'MongoDB', 'MySQL', 'DynamoDB', 'SQLite', 'Mongoose ODM'],
  'Cloud & DevOps': ['AWS Lambda', 'API Gateway', 'Amazon S3', 'Docker'],
  Tools: ['Git', 'GitLab', 'Jira', 'Postman', 'Visual Studio Code', 'Eclipse', 'Android Studio', 'Windows PowerShell'],
  'Software Engineering': ['Object-Oriented Programming', 'MVC Architecture', 'SDLC', 'Agile/Scrum', 'API Design', 'Software Testing', 'Debugging', 'Version Control', 'Regular Expressions'],
  'Operating Systems': ['Linux', 'Windows']
};

export const projects = [
  {
    name: 'Personal Portfolio Management Platform',
    role: 'Sole Developer',
    link: 'https://github.com/NextLevelProgramming0/MyWebPage',
    description: 'Designed and developed a full-stack portfolio management platform that centralizes professional experience, technical projects, education, certifications, and technical skills. Architected a decoupled React and Django REST Framework application backed by PostgreSQL and RESTful APIs. Implemented JWT authentication, protected endpoints, a normalized database schema, reusable React components, registration, login, and email verification.',
    technologies: 'React, JavaScript, Python, Django, Django REST Framework, PostgreSQL, JWT, REST APIs, Git'
  },
  {
    name: 'Full Stack Management Platform',
    role: 'Full Stack Developer',
    link: 'https://github.com/NextLevelProgramming0/CS-465-Full-Stack-Development-I',
    description: 'Developed an Angular, Node.js, Express.js, and MongoDB management application with a modular client-server architecture, RESTful services, CRUD workflows, Express middleware, validation, authentication handling, Mongoose schemas, Angular reactive forms, dependency-injected services, route guards, and asynchronous HTTP communication.',
    technologies: 'Angular, TypeScript, Node.js, Express.js, MongoDB, Mongoose ODM, REST APIs, Postman, Git'
  },
  {
    name: 'Serverless Cloud Application Platform',
    role: 'Cloud Application Developer',
    link: 'https://github.com/NextLevelProgramming0/CS-470-Full-Stack-Development-II',
    description: 'Designed an AWS serverless backend using Lambda, API Gateway, DynamoDB, Amazon S3, and Docker. Developed stateless services, API routing and mappings, authorization workflows, DynamoDB access patterns, integrated storage/compute/API services, reproducible containers, and cloud integration testing.',
    technologies: 'AWS Lambda, API Gateway, DynamoDB, Amazon S3, Docker, REST APIs, Git'
  },
  {
    name: 'Object-Oriented Java Application Suite',
    role: 'Software Developer',
    link: 'https://github.com/NextLevelProgramming0/Operating-Platforms',
    additionalLink: 'https://github.com/NextLevelProgramming0/Software-Test-Automation-QA',
    description: 'Developed modular Java applications using inheritance, polymorphism, encapsulation, abstraction, reusable class hierarchies, layered architecture, and maintainable design patterns. Built JUnit automated tests for functional, regression, and edge-case validation and applied debugging, exception handling, and root-cause analysis.',
    technologies: 'Java, JUnit, Object-Oriented Programming, Software Testing, Git'
  }
];

export const experiences = [
  {
    title: 'Software Developer (Volunteer) - Remote',
    company: 'JerseySTEM',
    duration: 'March 2026 - Present',
    description: 'Develop workflow automation with Google Apps Script for volunteer management and administration. Build integrations among Google Sheets, Gmail, Google Drive, Google Calendar, and external REST APIs; create reusable automation modules; automate reporting, scheduling, notifications, and records; synchronize operational data; troubleshoot integrations; participate in Agile planning, reviews, testing, and delivery; and maintain technical documentation.'
  },
  {
    title: 'Enteral Customer Service Representative',
    company: 'Johns Hopkins Care at Home Team',
    duration: 'October 2018 - Present',
    description: 'Manage healthcare documentation, patient records, and operational information across enterprise platforms. Use Epic Hyperspace, Brightree, and HomeCare360; investigate documentation discrepancies and processing exceptions; coordinate with clinical, billing, warehouse, and support teams; perform quality-control, record validation, and compliance reviews; and improve operational efficiency and data accuracy.'
  },
  {
    title: 'Billing & Procurement Associate',
    company: 'BGE Home',
    duration: 'August 2017 - November 2018',
    description: 'Processed procurement transactions, purchasing documentation, billing records, and operational data. Validated purchasing and billing through reconciliation, auditing, transaction review, and verification; supported workflow coordination and purchasing administration; maintained reporting and compliance records; and supported billing accuracy initiatives.'
  },
  {
    title: 'Material Handler',
    company: 'BGE Home',
    duration: 'November 2016 - October 2018',
    description: 'Maintained inventory accuracy through tracking, auditing, reconciliation, and transaction verification. Used Microsoft Access, Excel, and Great Plains; coordinated inventory movement, order fulfillment, logistics, and warehouse workflows; and supported inventory control through audits, reporting, and documentation.'
  }
];

export const education = {
  degree: 'Bachelor of Science in Computer Science (Software Engineering)',
  institution: 'Southern New Hampshire University',
  years: '2021-2025'
};

export const contact = {
  location: 'Baltimore, MD',
  phone: '443-337-4042',
  emails: ['quickdarius1@gmail.com', 'quickdarius@yahoo.com'],
  linkedin: 'https://www.linkedin.com/in/darius-quick-a75726168/',
  workAuthorization: 'U.S. Citizen'
};
